import React, { useState, useEffect, Fragment } from 'react';
import './styles.scss';
import AdminContentCard from '../../common/AdminContentCard';
import AdminContentUsers from '../../common/AdminContentUsers';
import { connect } from 'react-redux';
import { noop } from '../../common/propTypes';
import PropTypes from 'prop-types';

import campusIcon from './../../icons/campus.png';
import LoaderGif from '../../icons/LoaderGif.gif';

import { Modal } from 'react-bootstrap';
import { getPartnerLicense } from '../auth/actions';
import {
    usersRequested,
    deleteAdminsRequested,
    addAdminsRequested,
    adminsRequested,
    // citizenScientistRequested,
    AddCitizenScientistRequested,
    deleteCitizenScientistRequested,
    addChildAdminRequested,
    childInspireCampusPartnerRequested,
    childInspirePartnerRequested,
    removeChildAdminRequested,
    createPartnerREquested,
    clearErrorState,
    deleteInviteRequested,
} from './actions';
import {
    getAdmins,
    getUsers,
    getAdminsLoading,
    getAdminError,
    getCitizenScientist,
    getCitizenScientistLoading,
    getChildInspirePartners,
    getChildInspirePartnersLoading,
    getChildCampusPartners,
    getChildCampusPartnersLoading,
    getUserId,
    getdeleteAdminError,
    getAddScientistError,
    getDeleteScientistError,
    getAddAdminError,
    getAddAdminSuccess,
    getAddScientistSuccess,
    getAddChildAdminError,
    getAddChildAdminErrorId,
    getRemoveChildAdminError,
    getRemoveChildAdminErrorId,
    getcreatePartnerError,
    getaddAdminRequested,
    getAddScientistRequested,
    getAddChildAdminRequested,
    getChildAdminRequestedId,
    getCreatePartnerRequested,
    getDeleteUserRequested,
    getChildAdminProgress,
    getChildId,
    usersLoading,

    // partnerProcessing,
} from './selectors';
import {
    getUserPermissionsKeys,
    getPartnerLicenseState,
} from '../auth/selectors';
import {
    ADMIN_TAB_VIEW_PERMISSIONS,
    ADMIN_USER_VIEW,
    INSPIRE_PARTNER_VIEW,
    INSPIRE_CAMPUS_PARTNER_VIEW,
    ADMIN_USER_CREATE,
    INSPIRE_PARTNER_CREATE,
    INSPIRE_PARTNER_DELETE,
    INSPIRE_CAMPUS_PARTNER_CREATE,
    INSPIRE_CAMPUS_PARTNER_DELETE,
    CAMPUS,
    INSPIRE,
} from './constants';

function Admin({
    onLoad,
    admins,
    users,
    onDeleteUser,
    onAddAdmin,
    permissions,
    loadingPartners,
    loadingCampus,
    onAddScientist,
    onPartnerCreate,
    partners,
    onAddChildUser,
    onRemoveChildUser,
    campus,
    onDeleteScientist,
    onDeleteInvite,
    addChildAdminError,
    addChildAdminErrorId,
    deleteChildAdminError,
    deleteChildAdminErrorId,
    createPartnerError,
    clearErrors,
    addChildAdminRequestedState,
    addChildAdminRequestedIdState,

    deleteUserStatus,
    createPartnerStatus,
    partnerRequested,
    error,
    partnerLicense,
    userLoading,

    childPartnerInProgress,
    childPartnerInProgressId,
}) {
    const [tabview, setTabView] = useState(false);
    const [deleteUserModal, setDeleteUserModal] = useState(false);
    const [deleteUserId, setDeleteUserId] = useState(false);
    const [deleteUserChildId, setDeleteUserChildId] = useState(false);
    const [deleteUserType, setDeleteUserType] = useState(false);
    const [removeChildType, setRemoveChildType] = useState(false);
    const [deleteInviteParams, setDeleteInviteParams] = useState(null);

    function checkPermission(userPerm = [], viewPerm = []) {
        viewPerm.forEach((perm) => {
            if (userPerm.includes(perm)) {
                setTabView(true);
            }
        });
    }

    useEffect(() => {
        onLoad();
        checkPermission(permissions, ADMIN_TAB_VIEW_PERMISSIONS);
    }, []);

    useEffect(() => {
        if (deleteUserStatus === false) UserModalClose();
    }, [deleteUserStatus]);

    const UserModalOpen = () => {
        setDeleteUserModal(true);
    };

    const UserModalClose = () => {
        setDeleteUserModal(false);
    };

    const addUser = (type, email) => {
        switch (type) {
            case 'ADMIN': {
                onAddAdmin(email);
                break;
            }
            case 'SCIENTIST': {
                onAddScientist(email);
                break;
            }
        }
    };

    const createPartner = (partnerDetails) => {
        onPartnerCreate(partnerDetails);
    };

    const addChildUser = (childId, email, childType) => {
        onAddChildUser(childId, email, childType);
    };

    const removeChildUser = (childId, userId, childType) => {
        UserModalOpen();
        setDeleteUserChildId(childId);
        setDeleteUserId(userId);
        setDeleteUserType('CHILD');
        setRemoveChildType(childType);
    };

    const deleteUser = () => {
        switch (deleteUserType) {
            case 'ADMIN': {
                onDeleteUser(deleteUserId);
                break;
            }
            case 'SCIENTIST': {
                onDeleteScientist(deleteUserId);
                break;
            }
            case 'CHILD': {
                onRemoveChildUser(
                    deleteUserChildId,
                    deleteUserId,
                    removeChildType,
                );
                break;
            }
            case 'INVITE': {
                let { email, partnerId, sectionType } = deleteInviteParams;
                onDeleteInvite(email, partnerId, sectionType);
                break;
            }
        }
    };

    const deletePartnerInvite = (email, partnerId, sectionType) => {
        setDeleteUserModal(true);
        setDeleteUserType('INVITE');
        setDeleteInviteParams({ email, partnerId, sectionType });
    };

    return (
        <>
            <Fragment>
                {/* <h1>Impact Admin</h1> */}
                {tabview ? (
                    <>
                        <h1>Impact Admin</h1>
                        <div className="admin-section">
                            <div className="col">
                                <div className="tab-wrapper">
                                    <ul
                                        className="nav nav-tabs"
                                        id="myTab"
                                        role="tablist"
                                    >
                                        <li className="nav-item">
                                            <a
                                                className="nav-link active"
                                                id="tab-01"
                                                data-toggle="tab"
                                                href="#admin"
                                                role="tab"
                                                aria-controls="admin"
                                                aria-selected="true"
                                            >
                                                Users
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className="nav-link"
                                                id="tab-02"
                                                data-toggle="tab"
                                                href="#package"
                                                role="tab"
                                                aria-controls="package"
                                                aria-selected="false"
                                            >
                                                Partners
                                            </a>
                                        </li>
                                    </ul>
                                    <div
                                        className="tab-content"
                                        id="myTabContent"
                                    >
                                        <div
                                            className="tab-pane fade show active"
                                            id="admin"
                                            role="tabpanel"
                                            aria-labelledby="tab-01"
                                        >
                                            <ul className="list-style">
                                                {permissions.includes(
                                                    ADMIN_USER_VIEW,
                                                ) ? (
                                                    <AdminContentUsers
                                                        users={
                                                            users
                                                                ? users.users
                                                                : []
                                                        }
                                                        count={
                                                            users &&
                                                            users.licenseCount
                                                        }
                                                        loading={
                                                            error
                                                                ? false
                                                                : userLoading
                                                        }
                                                        error={error}
                                                    />
                                                ) : null}
                                            </ul>
                                        </div>
                                        <div
                                            className="tab-pane fade"
                                            id="package"
                                            role="tabpanel"
                                            aria-labelledby="tab-02"
                                        >
                                            <ul className="list-style">
                                                {permissions.includes(
                                                    INSPIRE_PARTNER_VIEW,
                                                ) ? (
                                                    <AdminContentCard
                                                        onCancelInvite={(
                                                            email,
                                                            partnerId = null,
                                                        ) =>
                                                            deletePartnerInvite(
                                                                email,
                                                                partnerId,
                                                                'Inspire',
                                                            )
                                                        }
                                                        section={'ADMIN'}
                                                        cardType={'ACCORDION'}
                                                        heading={
                                                            'Inspire Partners'
                                                        }
                                                        inputTitle={
                                                            'ADD ADMIN ACCOUNT'
                                                        }
                                                        users={
                                                            admins
                                                                ? admins.users
                                                                : []
                                                        }
                                                        countText={
                                                            'LICENSES USED'
                                                        }
                                                        count={
                                                            partners &&
                                                            partners.licenseCount
                                                                ? partners
                                                                      .licenseCount
                                                                      .currentPartnersCount
                                                                : null
                                                        }
                                                        loading={
                                                            loadingPartners
                                                        }
                                                        onPartnerCreate={(
                                                            partnerDetails,
                                                        ) =>
                                                            createPartner({
                                                                ...partnerDetails,
                                                                partnerTypeKey: INSPIRE,
                                                            })
                                                        }
                                                        total={
                                                            partnerLicense.inspire_partner
                                                        }
                                                        childTotal={
                                                            partnerLicense.inspire_partner_admin_users
                                                        }
                                                        onAddUser={(email) =>
                                                            addUser(
                                                                'SCIENTIST',
                                                                email,
                                                            )
                                                        }
                                                        onAddChildUser={(
                                                            childId,
                                                            email,
                                                        ) =>
                                                            addChildUser(
                                                                childId,
                                                                email,
                                                                'Inspire',
                                                            )
                                                        }
                                                        showAddButton={
                                                            permissions.includes(
                                                                ADMIN_USER_CREATE,
                                                            )
                                                                ? true
                                                                : false
                                                        }
                                                        showDeleteButton={
                                                            permissions.includes(
                                                                INSPIRE_PARTNER_DELETE,
                                                            )
                                                                ? true
                                                                : false
                                                        }
                                                        showPartnerButton={
                                                            permissions.includes(
                                                                INSPIRE_PARTNER_CREATE,
                                                            )
                                                                ? true
                                                                : false
                                                        }
                                                        partners={
                                                            partners
                                                                ? partners.partners
                                                                : []
                                                        }
                                                        onRemoveChildUser={(
                                                            childId,
                                                            userId,
                                                        ) =>
                                                            removeChildUser(
                                                                childId,
                                                                userId,
                                                                'Inspire',
                                                            )
                                                        }
                                                        emailError={
                                                            addChildAdminError
                                                        }
                                                        emailChildId={
                                                            addChildAdminErrorId
                                                        }
                                                        deleteError={
                                                            deleteChildAdminError
                                                        }
                                                        deleteChildId={
                                                            deleteChildAdminErrorId
                                                        }
                                                        createPartnerError={
                                                            createPartnerError
                                                        }
                                                        childRequested={
                                                            addChildAdminRequestedState
                                                        }
                                                        childRequestedId={
                                                            addChildAdminRequestedIdState
                                                        }
                                                        partnerCreating={
                                                            createPartnerStatus
                                                        }
                                                        onClearErrors={() =>
                                                            clearErrors()
                                                        }
                                                        isPartnerCreateRequested={
                                                            partnerRequested
                                                        }
                                                        childPartnerInProgress={
                                                            childPartnerInProgress
                                                        }
                                                        childPartnerInProgressId={
                                                            childPartnerInProgressId
                                                        }
                                                    />
                                                ) : null}

                                                {permissions.includes(
                                                    INSPIRE_CAMPUS_PARTNER_VIEW,
                                                ) ? (
                                                    <AdminContentCard
                                                        onCancelInvite={(
                                                            email,
                                                            partnerId = null,
                                                        ) =>
                                                            deletePartnerInvite(
                                                                email,
                                                                partnerId,
                                                                'Campus',
                                                            )
                                                        }
                                                        section={'ADMIN'}
                                                        heading="Campus Partners"
                                                        users={
                                                            admins
                                                                ? admins.users
                                                                : []
                                                        }
                                                        inputTitle={
                                                            'ADD ADMIN ACCOUNT'
                                                        }
                                                        countText={
                                                            'LICENSES USED'
                                                        }
                                                        count={
                                                            campus &&
                                                            campus.licenseCount
                                                                ? campus
                                                                      .licenseCount
                                                                      .currentPartnersCount
                                                                : null
                                                        }
                                                        loading={loadingCampus}
                                                        total={
                                                            partnerLicense.inspire_campus_partner
                                                        }
                                                        childTotal={
                                                            partnerLicense.inspire_campus_partner_admin_users
                                                        }
                                                        cardType={'ACCORDION'}
                                                        onAddUser={(email) =>
                                                            addUser(
                                                                'SCIENTIST',
                                                                email,
                                                            )
                                                        }
                                                        onAddChildUser={(
                                                            childId,
                                                            email,
                                                        ) =>
                                                            addChildUser(
                                                                childId,
                                                                email,
                                                                'Campus',
                                                            )
                                                        }
                                                        showAddButton={
                                                            permissions.includes(
                                                                ADMIN_USER_CREATE,
                                                            )
                                                                ? true
                                                                : false
                                                        }
                                                        showDeleteButton={
                                                            permissions.includes(
                                                                INSPIRE_CAMPUS_PARTNER_DELETE,
                                                            )
                                                                ? true
                                                                : false
                                                        }
                                                        showPartnerButton={
                                                            permissions.includes(
                                                                INSPIRE_CAMPUS_PARTNER_CREATE,
                                                            )
                                                                ? true
                                                                : false
                                                        }
                                                        partners={
                                                            campus
                                                                ? campus.partners
                                                                : []
                                                        }
                                                        onPartnerCreate={(
                                                            partnerDetails,
                                                        ) =>
                                                            createPartner({
                                                                ...partnerDetails,
                                                                partnerTypeKey: CAMPUS,
                                                            })
                                                        }
                                                        onRemoveChildUser={(
                                                            childId,
                                                            userId,
                                                        ) =>
                                                            removeChildUser(
                                                                childId,
                                                                userId,
                                                                'Campus',
                                                            )
                                                        }
                                                        emailError={
                                                            addChildAdminError
                                                        }
                                                        emailChildId={
                                                            addChildAdminErrorId
                                                        }
                                                        deleteError={
                                                            deleteChildAdminError
                                                        }
                                                        deleteChildId={
                                                            deleteChildAdminErrorId
                                                        }
                                                        createPartnerError={
                                                            createPartnerError
                                                        }
                                                        childRequested={
                                                            addChildAdminRequestedState
                                                        }
                                                        childRequestedId={
                                                            addChildAdminRequestedIdState
                                                        }
                                                        partnerCreating={
                                                            createPartnerStatus
                                                        }
                                                        onClearErrors={() =>
                                                            clearErrors()
                                                        }
                                                        isPartnerCreateRequested={
                                                            partnerRequested
                                                        }
                                                        childPartnerInProgress={
                                                            childPartnerInProgress
                                                        }
                                                        childPartnerInProgressId={
                                                            childPartnerInProgressId
                                                        }
                                                    />
                                                ) : (
                                                    <div className="admin-content-box campus-support">
                                                        <div className="row justify-content-center">
                                                            <div className="col-6">
                                                                <div className="row justify-content-center">
                                                                    <div className="col-4 campus-image">
                                                                        <img
                                                                            src={
                                                                                campusIcon
                                                                            }
                                                                            width={
                                                                                '100%'
                                                                            }
                                                                            height={
                                                                                '100%'
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="row text-center justify-content-center campus-heading">
                                                                    <h5>
                                                                        Campus
                                                                        Partners
                                                                    </h5>
                                                                </div>
                                                                <div className="row text-center justify-content-center">
                                                                    If you wish
                                                                    to create
                                                                    Campus
                                                                    Partners,
                                                                </div>
                                                                <div className="row text-center justify-content-center mb-3">
                                                                    please
                                                                    contact our
                                                                    support team
                                                                    at,
                                                                    <span
                                                                        className={
                                                                            'fw-600'
                                                                        }
                                                                    >
                                                                        &nbsp;
                                                                        support@litterati.org.
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        {permissions.includes(ADMIN_USER_VIEW) ? (
                            <>
                                <h1>Inspire Admin</h1>
                                <div className="list-style">
                                    <AdminContentUsers
                                        users={users ? users.users : []}
                                        count={users && users.licenseCount}
                                        loading={error ? false : userLoading}
                                        error={error}
                                    />
                                </div>
                            </>
                        ) : null}
                    </>
                )}

                <div className="admin-delete-modal">
                    <Modal
                        show={deleteUserModal}
                        onHide={UserModalClose}
                        dialogClassName={'admin-delete-modal'}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        centered={true}
                        animation={true}
                    >
                        <div className="row">
                            <div className="col-12">
                                <div className="row title">Delete Account</div>
                                <div className="row">
                                    Are you sure you want to delete this
                                    account?
                                </div>
                                <div className="row">
                                    <button
                                        className={
                                            'btn btn-block delete-admin-button'
                                        }
                                        type={'button'}
                                        onClick={() => deleteUser()}
                                    >
                                        {deleteUserStatus ? (
                                            <img
                                                src={LoaderGif}
                                                width={'25px'}
                                                height={'25px'}
                                            />
                                        ) : (
                                            'Delete'
                                        )}
                                    </button>
                                </div>

                                <div className="row mt-1">
                                    <button
                                        className={
                                            'btn btn-block delete-button-cancel'
                                        }
                                        type={'button'}
                                        onClick={() => UserModalClose()}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
            </Fragment>
        </>
    );
}

Admin.propTypes = {
    onLoad: PropTypes.func,
    admins: PropTypes.object,
    users: PropTypes.object,
    loadingAdmins: PropTypes.bool,
    onDeleteUser: PropTypes.func,
    onDeleteScientist: PropTypes.func,
    onDeleteInvite: PropTypes.func,
    onAddAdmin: PropTypes.func,
    onAddChildUser: PropTypes.func,
    onRemoveChildUser: PropTypes.func,
    onAddScientist: PropTypes.func,
    onPartnerCreate: PropTypes.func,
    permissions: PropTypes.array,
    scientist: PropTypes.object,
    loadingScientist: PropTypes.bool,
    partners: PropTypes.object,
    loadingPartners: PropTypes.bool,
    campus: PropTypes.object,
    loadingCampus: PropTypes.bool,
    userId: PropTypes.number,

    addAdminError: PropTypes.string,
    deleteAdminError: PropTypes.string,
    addAdminSuccess: PropTypes.string,
    addScientistSuccess: PropTypes.string,
    addScientistError: PropTypes.string,
    deleteScientistError: PropTypes.string,
    addChildAdminError: PropTypes.string,
    addChildAdminErrorId: PropTypes.string,
    deleteChildAdminError: PropTypes.string,
    deleteChildAdminErrorId: PropTypes.string,
    createPartnerError: PropTypes.string,
    error: PropTypes.string,

    addAdminsRequestedState: PropTypes.bool,
    addScientistRequestedState: PropTypes.bool,
    addChildAdminRequestedState: PropTypes.bool,
    addChildAdminRequestedIdState: PropTypes.number,

    deleteUserStatus: PropTypes.bool,
    createPartnerStatus: PropTypes.bool,

    clearErrors: PropTypes.func,
    partnerRequested: PropTypes.bool,

    partnerLicense: PropTypes.object,

    childPartnerInProgress: PropTypes.bool,

    childPartnerInProgressId: PropTypes.number,
    userLoading: PropTypes.bool,
};

Admin.defaultProps = {
    // selected: null,
    onLoad: noop,
    users: null,
    admins: {
        licenseCount: {
            totalAdminsCount: 0,
            currentAdminsCount: 0,
        },
    },
    loadingAdmins: false,
    scientist: {
        licenseCount: {
            totalAdminsCount: 0,
            currentAdminsCount: 0,
        },
    },
    loadingScientist: false,
    partners: {
        licenseCount: {
            totalAdminsCount: 0,
            currentAdminsCount: 0,
        },
    },
    loadingPartners: false,
    campus: {
        licenseCount: {
            totalAdminsCount: 0,
            currentAdminsCount: 0,
        },
    },
    loadingCampus: false,
    onDeleteUser: noop,
    onDeleteScientist: noop,
    onAddAdmin: noop,
    onAddScientist: noop,
    onAddChildUser: noop,
    onRemoveChildUser: noop,
    onDeleteInvite: noop,
    onPartnerCreate: noop,
    error: null,
    permissisions: [],
    userId: null,

    addAdminError: null,
    addAdminSuccess: null,
    addScientistSuccess: null,
    deleteAdminError: null,
    addScientistError: null,
    deleteScientistError: null,
    addChildAdminError: null,
    addChildAdminErrorId: null,
    deleteChildAdminError: null,
    createPartnerError: null,

    addAdminsRequestedState: false,
    addScientistRequestedState: false,
    addChildAdminRequestedState: false,
    addChildAdminRequestedIdState: null,

    deleteUserStatus: false,
    createPartnerStatus: false,

    clearErrors: noop,
    partnerLicense: {},
    userLoading: false,
};

const mapStateToProps = (state) => {
    return {
        userLoading: usersLoading(state),
        admins: getAdmins(state),
        users: getUsers(state),
        loadingAdmins: getAdminsLoading(state),
        error: getAdminError(state),
        permissions: getUserPermissionsKeys(state),
        scientist: getCitizenScientist(state),
        loadingScientist: getCitizenScientistLoading(state),
        partners: getChildInspirePartners(state),
        loadingPartners: getChildInspirePartnersLoading(state),
        campus: getChildCampusPartners(state),
        loadingCampus: getChildCampusPartnersLoading(state),
        userId: getUserId(state),

        addAdminError: getAddAdminError(state),
        addAdminSuccess: getAddAdminSuccess(state),
        addScientistSuccess: getAddScientistSuccess(state),
        deleteAdminError: getdeleteAdminError(state),
        addScientistError: getAddScientistError(state),
        deleteScientistError: getDeleteScientistError(state),
        addChildAdminError: getAddChildAdminError(state),
        addChildAdminErrorId: getAddChildAdminErrorId(state),
        deleteChildAdminError: getRemoveChildAdminError(state),
        deleteChildAdminErrorId: getRemoveChildAdminErrorId(state),
        createPartnerError: getcreatePartnerError(state),

        deleteUserStatus: getDeleteUserRequested(state),
        addAdminsRequestedState: getaddAdminRequested(state),
        addScientistRequestedState: getAddScientistRequested(state),
        addChildAdminRequestedState: getAddChildAdminRequested(state),
        addChildAdminRequestedIdState: getChildAdminRequestedId(state),
        partnerRequested: getCreatePartnerRequested(state),

        partnerLicense: getPartnerLicenseState(state),

        childPartnerInProgress: getChildAdminProgress(state),

        childPartnerInProgressId: getChildId(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoad: () => {
            dispatch(adminsRequested());
            dispatch(usersRequested());
            dispatch(childInspirePartnerRequested());
            dispatch(childInspireCampusPartnerRequested());
            dispatch(getPartnerLicense());
        },
        onAddChildUser: (childId, email, childType) =>
            dispatch(addChildAdminRequested(childId, email, childType)),
        onRemoveChildUser: (childId, userId, childType) =>
            dispatch(removeChildAdminRequested(childId, userId, childType)),
        onDeleteUser: (id) => dispatch(deleteAdminsRequested(id)),
        onDeleteScientist: (id) =>
            dispatch(deleteCitizenScientistRequested(id)),
        onAddAdmin: (email) => dispatch(addAdminsRequested(email)),
        onAddScientist: (email) =>
            dispatch(AddCitizenScientistRequested(email)),
        onPartnerCreate: (partnerDetails) =>
            dispatch(createPartnerREquested(partnerDetails)),
        clearErrors: () => dispatch(clearErrorState()),
        onDeleteInvite: (email, partnerId, sectionType) =>
            dispatch(deleteInviteRequested(email, partnerId, sectionType)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Admin);
